export default __webpack_public_path__ + "static/9-6fe5c041fa384c6faea9b2e09640237f.png";